import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import NeedleAnalyticsApiService from '@/api/needleAnalytics/NeedleAnalyticsApiService';

import { needleAnalytic } from '@/services/needle';

const needleService = new NeedleAnalyticsApiService(needleAnalytic);

export default function useCheckoutNeedle(startLoadingTrigger: boolean) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const firstLoad = useRef<boolean>(true);

  const handleStartLoading = async () => {
    await needleService.removeNeedleScript();
  };

  const handleEndLoading = async () => {
    await needleService.reloadNeedleScript();
  };

  useEffect(() => {
    if (!firstLoad.current && startLoadingTrigger) {
      handleStartLoading();
    }
  }, [startLoadingTrigger]);

  useEffect(() => {
    if (!firstLoad.current) {
      handleEndLoading();
    }
    firstLoad.current = false;
  }, [pathname, searchParams, startLoadingTrigger]);

  return {};
}
